// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table .text-right {\n  text-align: right;\n}\n.table .text-left {\n  text-align: left;\n}\n.table .text-center {\n  text-align: center;\n}\n.table-responsive {\n  margin-bottom: 0px !important;\n  font-size: 0.875rem;\n}", ""]);
// Exports
module.exports = exports;
